import {ILoraForwarderBasicStationServerConfigService} from './ILoraForwarderBasicStationServerConfig.service';

import {Inject, injectable} from 'inversify-props';

import {IApiService} from '@/services/IApi.service';

@injectable()
export class LoraForwarderBasicStationServerConfigService implements ILoraForwarderBasicStationServerConfigService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  constructor(private path: string) {

  }

  public async getServerUri(): Promise<string> {
    return await this.apiService.get(`${this.path}/server/uri`);
  }

  public async setServerUri(address: string): Promise<void> {
    return await this.apiService.put(`${this.path}/server/uri`, address);
  }

  public async getServerCertificate(): Promise<string> {
    return await this.apiService.get(`${this.path}/server/certificate`);
  }

  public async setServerCertificate(certificate: string): Promise<void> {
    return await this.apiService.put(`${this.path}/server/certificate`, certificate);
  }

  public async getClientCertificate(): Promise<string> {
    return await this.apiService.get(`${this.path}/client/certificate`);
  }

  public async setClientCertificate(certificate: string): Promise<void> {
    return await this.apiService.put(`${this.path}/client/certificate`, certificate);
  }

  public async getClientKey(): Promise<string> {
    return await this.apiService.get(`${this.path}/client/key`);
  }

  public async setClientKey(key: string): Promise<void> {
    return await this.apiService.put(`${this.path}/client/key`, key);
  }

  public async getClientToken(): Promise<string> {
    return await this.apiService.get(`${this.path}/client/token`);
  }

  public async setClientToken(token: string): Promise<void> {
    return await this.apiService.put(`${this.path}/client/token`, token);
  }
}
